import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);

export const adminLogin = (email, password) =>
  axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });

export const getMe = () => axios.get(`${API}/auth/me`, { withCredentials: true });

export const adminLogout = () =>
  axios.post(`${API}/auth/logout`, {}, { withCredentials: true });

export const getLeads = (type) =>
  axios.get(`${API}/admin/leads${type ? `?type=${type}` : ""}`, { withCredentials: true });

export const updateLeadStatus = (id, status) =>
  axios.patch(`${API}/admin/leads/${id}`, { status }, { withCredentials: true });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(" ");
  return "Une erreur est survenue. Veuillez réessayer.";
}

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};
